<template>
  <div>
    <div class="card-header">
      <div class="card-header-title" v-if="isLoading">
        <b-skeleton
          width="180px"
          height="14px"
          class="mx-auto mb-2"
        ></b-skeleton>
        <b-skeleton width="20%" height="45px" class="mx-auto mb-3"></b-skeleton>
        <b-skeleton
          width="220px"
          height="20px"
          class="mx-auto mb-4"
        ></b-skeleton>
        <div class="card-header-text-container">
          <b-skeleton
            width="300px"
            height="14px"
            class="mx-auto mb-2"
          ></b-skeleton>
          <b-skeleton width="250px" height="14px" class="mx-auto"></b-skeleton>
        </div>
      </div>

      <div class="card-header-title" v-else-if="!hasShowError">
        <div class="card-header-title-text" v-if="hasShowTable">
          Tabela de coparticipação
        </div>
        <div class="plan-name">{{ title }}</div>
        <div class="cad-number">{{ cardNumber }}</div>
      </div>

      <div class="card-header-text" v-if="hasShowTable && !isLoading">
        <div class="card-header-text-container">
          <div class="card-header-text-span">
            {{ mainMessage }}
          </div>
          <div class="card-header-text-span">
            {{ caption }}
            <span class="black-remover">
              {{ textComplementar }}
            </span>
          </div>
        </div>
      </div>

      <div
        class="card-header-text-no-content"
        v-if="!hasShowTable && !hasShowError && !isLoading"
      >
        <div>
          <strong> Seu plano não possui coparticipação </strong>
        </div>
        <div class="card-header-text-2-no-content">
          <span
            >Seu plano cobre integralmente os procedimentos, por isso não há uma
            tabela de coparticipação para exibir.</span
          >
        </div>
      </div>

      <div class="card-header-text-error" v-if="hasShowError">
        <div class="info-circle">
          <img class="info-error" src="../../assets/images/info.svg" />
        </div>
        <div>
          <strong>Não foi possível carregar as informações</strong>
        </div>
        <div class="card-header-text-2-error">
          <span
            >Por favor, atualize a página ou tente novamente mais tarde.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    mainMessage: String,
    caption: String,
    textComplementar: String,
    cardNumber: String,
    hasShowTable: Boolean,
    hasShowError: Boolean,
    isLoading: Boolean,
  },
};
</script>

<style scoped>
.card-header-title-text {
  color: var(--pure-black);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
}
.info-circle img {
  width: 24px;
}
.card-header-text-error strong {
  font-family: UnimedSlab-SemiBold;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px;
}
.card-header-text-2-error {
  font-family: UnimedSans-Regular;
  font-size: 14px;
}
.card-header {
  width: 100%;
  display: block;
  text-align: center;
  background-color: var(--bg-surface-secondary);
}

.card-header-title {
  color: var(--color-brand-primary);
  font-size: 35px;
  font-family: UnimedSlab-SemiBold;
  width: auto;
  margin: auto;
  padding-top: 40px;
}

.card-header-text {
  margin-top: 16px;
  font-size: 14px;
  font-family: UnimedSans-SemiBold;
}

.card-header-text-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 40px;
}

.card-header-text span {
  font-weight: 500;
}

.card-header-title .cad-number {
  margin-top: 16px;
  color: var(--color-brand-primary);
  font-family: "Roboto-Slab";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 19.2px;
}

.card-header-text-span {
  display: flex;
  justify-content: center;
  color: var(--text-primary);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.25px;
}

.plan-name {
  margin-top: 8px;
  color: var(--color-brand-primary);
  font-family: "Roboto-Slab";
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
}

.black-remover {
  font-weight: normal !important;
}
@media (min-width: 320px) {
  .card-header {
    height: 280px;
  }
}
@media (min-width: 480px) {
  .card-header {
    height: 250px;
  }
}
</style>
